import { EMAILS } from './EMAILS';

function urlBuilder(...rest: string[]) {
	return `${rest.join('/')}`;
}

const base = 'https://arovy.com';

export const URLS = {
	CONTACT: urlBuilder(base, 'contact'),
	CUSTOMER_PACKAGE_UPGRADE: urlBuilder(base, 'customer-package-upgrade'),
	PRIVACY_POLICY: urlBuilder(base, 'privacy-policy'),
	SUPPORT_EMAIL: `mailto:${EMAILS.SUPPORT}`,
	TERMS_OF_SERVICE: urlBuilder(base, 'terms-of-service')
};
